
<f-dialog
    v-model       = "show"
    :width        = "500"
    :show-header  = "true"
    :hide-actions = "false"
    :inset        = "true"
    content-class = "dialog-border"
    :title        = "$t('disposition.order.title')"
    @store        = "onStore"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <v-form ref="form">
            <v-row class="no-frame">
                <v-col class="no-frame pr-2">
                    <v-text-field
                        :label  = "$t('disposition.order.no')"
                        v-model = "order.no"
                        :rules  = "[ required ]"
                    />
                </v-col>

                <v-col class="no-frame pl-2">
                    <f-enum-select
                        v-model    = "order.status"
                        :label     = "$t('disposition.order.status')"
                        module     = "disposition"
                        type       = "dispositionOrderStatus"
                        :rules  = "[ required ]"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame col-9">
                    <f-enum-autocomplete
                        v-model  = "order.customer"
                        :label   = "$t('disposition.order.customer')"
                        module   = "msd"
                        type     = "customer"
                        :rules  = "[ required ]"
                    />
                </v-col>
                {{ color.hex }}
                <v-col class="no-frame col-3" style="text-align: right">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                elevation="0"
                                class="dialog-button mt-4 lm-border"
                                style="min-width: 100px!important;"
                                :color = "color"
                                v-on="on"
                            >
                                {{ $t('disposition.order.color') }}
                            </v-btn>
                        </template>
                        <v-color-picker
                            mode = "hexa"
                            value="color"
                            v-model="color"
                            hide-inputs
                            hide-sliders
                            hide-canvas
                            show-swatches
                            class="mx-auto"
                        ></v-color-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame">
                    <v-textarea
                        v-model        = "order.comment"
                        :label         = "$t('disposition.order.comment')"
                        :rows          = "4"
                        class          = "mt-3"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame mt-4">
                <v-col class="no-frame">
                    <f-title
                        :title = "$t('disposition.order.scope.title')"
                    />
                </v-col>
            </v-row>

            <p-order-scope
                v-model="order.scope"
            />
        </v-form>
    </template>
</f-dialog>
